import { api } from '@/shared/api/client';
import type {
  GetCourseRequest,
  GetContentsResponse,
} from '../model/dto';

export const getContents = async (params?: GetCourseRequest) => {
  const { data } = await api.get<GetContentsResponse>('/contents/', {
    params,
  });
  return data;
};
